import React from 'react';
import styles from './Policy.less'
import color from 'color';
import SvgX from '@wix/restaurants-components-css-modules/dist/svg/X/SvgX';
import {PolicyHelper} from '../../utils/policyHelper';

export class Policy extends React.Component {

    _onKeyUp = (event ) => {
        if ((event.key === 'Escape' || event.key === 'Esc')) {
            event.stopPropagation()
            this.props.onClose()
        }
    }

    componentDidMount() {
        document.addEventListener('keyup', this._onKeyUp,true);
        window.focus()
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this._onKeyUp,true);
    }

    render() {
        const {title, text, onClose, isCustomDesign, contextStyles, i18n} = this.props
        const customStyles = isCustomDesign ? styles.custom : ''
        const policyHelper = new PolicyHelper({isCustomDesign, contextStyles});
        return <div data-hook={'policies-modal'}

                    className={`${styles.pop} ${customStyles}`}>
            <button data-hook={'policies-modal-x-button'}

                    onClick={() => onClose()}
                    className={`${styles.closeButton} reservation-modal-close-bt  ${customStyles}`}><SvgX
                shapeRendering="initial" width={16} height={16}/></button>
            <div data-hook={'policies-modal-title'} className={`${styles.title} ${customStyles}`}>
                {title}
            </div>
            <div data-hook={'policies-modal-text'}
                 style={{pointerEvents: 'all', marginBottom: '30px', height: '100%', width: '100%', overflow: 'auto'}}>
                {text}
                <div data-hook={'padder'} style={{height: '50px'}}/>
            </div>
            <div style={{position: 'relative'}}>
                <div className={styles.textFader} style={{
                    width: '100%',
                    height: '47px',
                    backgroundImage: `linear-gradient(to bottom, ${color(policyHelper.getBackgroundColor()).alpha(0).rgbaString()} 1%, ${policyHelper.getBackgroundColor()} 100%)`
                }}/>
            </div>
            <div data-hook={'policies-modal-close-button'} className={`${styles.cta} ${customStyles}`}
                 onClick={() => onClose()}>
                {i18n.get('openrest_checkoutconfirmationview_policies_popup_CTA', 'Close')}
            </div>
        </div>
    }
}